const config = {
  id: 11,
  name: '活动商品',
  type: 1,
  module_code: 'biz_active_item',
  icon: 'icon-tms-item',
  font_icon: '&#xe669;',
  style_type: 1,
  link_type: 4,
  link_data: [],
  active_item: {}, // 选择活动
  property_data: {
    btn_text: '立即开卖',
    btn_bg: '#EC4000'
  },
  bg_color:'#fff',
  font_color:'#333',
  price_font_color:'#ec4000',
  btn_bg_color:'#ec4000',
  btn_font_color:'#fff',
  tips_bg_color:'#ec4000',
  tips_color:'#fff',
};
export default config;